import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from './cell-label.styles.js';

var _excluded = ["children"];
var CellLabel = function CellLabel(props) {
  var children = props.children,
      attrs = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React__default.createElement(Box, attrs, children);
};

export { CellLabel };
